<app-chat></app-chat>
<app-navbar></app-navbar>
<section class="movie">
<div class="container">
  <div class="row">
    <div class="col-5 col-sm-4 col-md-3 col-lg-2  ">
      <h5 class="filter-header">Filter by </h5>
      <ul class="filter-ul">
        <li class="filter-li" *ngFor="let i of links" (click)="changeMovie(i)">{{i}} movies <span class="float-right">({{data.length}})</span></li>
      </ul>
    </div>
    <div class="col-7 col-sm-8 col-md-9 col-lg-10 pl-4 pr-0">
      <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
        <div class="col" *ngFor="let i of data">
          <app-card [card]="i" ></app-card>
  </div>
    </div>
    </div>
  </div>

   
</div>
</section>

